import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import { ProductLogo, GOLD_GRADIENT } from "../components/ProductLogo";

/**
 * Scene 09 — Section 2 opener · Core Stack reveal.
 * Two product logos crisp and centre-stage (SOCIAL GO + SOCIAL PRO).
 * SOCIAL WEEK still blurred (the "one more thing" tease — yet to be unveiled).
 *
 * Slide is intentionally minimal — the bullet beats and the
 * "content engine" closing line live in the speaker notes.
 */

export default function Scene09_CoreStack() {
  return (
    <SceneShell variant="forest" align="left" data-testid="scene-core-stack">
      {/* Soft ambient glow */}
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 25% 50%, rgba(150,193,31,0.16) 0%, transparent 55%)",
            "radial-gradient(ellipse at 75% 50%, rgba(150,193,31,0.16) 0%, transparent 55%)",
            "radial-gradient(ellipse at 25% 50%, rgba(150,193,31,0.16) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1280px] mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="kn-eyebrow mb-6 text-center"
        >
          What's been built.
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.0, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-3xl sm:text-4xl lg:text-5xl text-white text-center mb-12"
          data-testid="core-stack-title"
        >
          <span className="text-white/85">Core</span>{" "}
          <span style={{ color: "#96C11F" }}>Packages.</span>
        </motion.h2>

        {/* Two big logos in the centre — Social Go + Social Pro */}
        <div className="relative">
          <div className="relative flex items-center justify-center gap-20 lg:gap-32 py-6">
            <motion.div
              initial={{ opacity: 0, y: 24, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 1.0, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
            >
              <ProductLogo
                name="GO"
                color="#96C11F"
                fontSize="clamp(56px, 6vw, 110px)"
                iconSize={64}
                testId="core-stack-go"
              />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 24, scale: 0.9 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 1.0, delay: 0.7, ease: [0.16, 1, 0.3, 1] }}
            >
              <ProductLogo
                name="PRO"
                color="#e2e8f0"
                fontSize="clamp(56px, 6vw, 110px)"
                testId="core-stack-pro"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </SceneShell>
  );
}
